import EatOutSection from "./eatOutSection";

export default EatOutSection;
